import moment from 'moment';

import { featureToggleInit } from '@guestyci/feature-toggle-fe';
import Resource from '@guestyci/agni';

import { get, USER_TOKEN_STORAGE_KEY } from 'mailerApi';
import { getListings } from 'property/properties.actions';
import { setItem } from 'utils/localStorage';

const initFeatureToggle = async () => {
  try {
    const { env } = Resource.create();
    const { accountId } = Resource.getCurrentUser();
    window.featureToggle = await featureToggleInit({ env, accountId });
  } catch (err) {
    console.error(err);
  }
};

const fetchInitData = async (dispatch) => {
  await initFeatureToggle();
  dispatch(getListings({ sort: 'nickname' }));
};

const forgotPassword = (hash) => {
  const host = window.location.hostname;

  return get(`/owners-portal/forgot-password/${host}/${hash}`, {}, {}, true);
};

const loginAsOwner = (userToken) => {
  setItem(USER_TOKEN_STORAGE_KEY, userToken);
};

const initMoment = (locale) => {
  moment.defineLocale('en-US-nonAmericanDates', {
    parentLocale: 'en-US',
  });
  moment.updateLocale('en-US-nonAmericanDates', {
    longDateFormat: {
      L: 'DD/MM/YYYY',
      LL: 'MMMM D, YYYY',
      LLL: 'MMMM D, YYYY h:mm A',
      LLLL: 'dddd, MMMM D, YYYY h:mm A',
      LT: 'h:mm A',
      LTS: 'h:mm:ss A',
    },
  });

  moment.locale(locale);
};

export { forgotPassword, loginAsOwner, initMoment, initFeatureToggle };

export default fetchInitData;
